// extracted by mini-css-extract-plugin
module.exports = {"containerFixed":"Footer_containerFixed__1r1Nl","row1":"Footer_row1__17q6_","col":"Footer_col__3mDY5","row2":"Footer_row2__vW7DE"};